import React from "react";
import PropTypes from "prop-types";
import numeral from "numeral";

const Utility = ({ utility, icons }) => {
  const {
    name,
    slug,
    city_subregion,
    max_population_served,
    nrw_value,
    network_length,
    retail_water_service,
    bulk_water_service,
    retail_wastewater_service,
    bulk_wastewater_service,
    utility_type,
  } = utility;

  const {
    dropletFullIcon,
    dropletHalfIcon,
    peopleIcon,
    networkIcon,
    nrwPurpleIcon,
  } = icons;

  return (
    <a
      href={`/data-hub/utilities/utility-profiles/${slug}`}
      target="_blank"
      rel="noopener noreferrer"
      className="href"
      key={name}
    >
      <div className="utility-info">
        <div className="top-row">
          <div className="utility-name">{name}</div>
          {(retail_water_service || bulk_water_service) &&
            <div className="tooltip-container">
              <div className="utility-icon"><img className="icon" src={dropletFullIcon} alt="water"/></div>
              <span className="tooltip-content">
                Water
              </span>
            </div>
          }
          {(retail_wastewater_service || bulk_wastewater_service) &&
            <div className="tooltip-container">
              <div className="utility-icon"><img className="icon" src={dropletHalfIcon} alt="wastewater"/></div>
              <span className="tooltip-content wastewater">
                Wastewater
              </span>
            </div>
          }
        </div>
        <div className="utility-location">{city_subregion}</div>
        <div className="utility-data">
          <div className="population tooltip-container">
            <img className="icon" src={peopleIcon} alt="pop served"/>
            <span>{max_population_served != 0 ? numeral(max_population_served).format("0[.]0a") : "-"}</span>
            <span className="tooltip-content">
              {max_population_served !== 0 ? numeral(max_population_served).format("0[.]0a") : "-"} population served
            </span>
          </div>
          <div className="network-length tooltip-container">
            <img className="icon pipe-icon" src={networkIcon} alt="network length"/>
            <span>{network_length === 0 ? "-" : numeral(network_length).format()} km</span>
            <span className="tooltip-content">
              {network_length === 0 ? "-" : numeral(network_length).format()} km cumulative pipe length
            </span>
          </div>
          <div className="nrw-rate tooltip-container">
            <img className="icon" src={nrwPurpleIcon} alt="nrw value"/>
            <span>{nrw_value === 0 ? "-%" : numeral(nrw_value).divide(100).format("0%", Math.floor)}</span>
            <span className="tooltip-content">
              {nrw_value === 0 ? "-%" : numeral(nrw_value).divide(100).format("0%", Math.floor)} NRW rate
            </span>
          </div>
          <div className="private-utility tooltip-container">
            <span>{utility_type}</span>
            <span className="tooltip-content">{utility_type}</span>
          </div>
        </div>
      </div>
    </a>
  );
};

Utility.propTypes = {
  utility: PropTypes.shape({}),
  icons: PropTypes.shape({})
};

export default Utility;
